import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getThreadByNodeId } from "../modules/firebaseAPI";
import ChatPageWrapper from "./ChatPage"; // ストーリー型
import ChatPagemapWrapper from "./ChatPagemap"; // マインドマップ型

const ChatRouter = ({ userId }) => {
  const { nodeId } = useParams();
  const [threadType, setThreadType] = useState(null);
  const [storyId, setStoryId] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchThread = async () => {
      //console.log("🔍 検索開始 nodeId:", nodeId);
      try {
        const thread = await getThreadByNodeId(nodeId);
        //console.log("✅ スレッド取得成功:", thread);
        setThreadType(thread.threadType);
        setStoryId(thread.id);
      } catch (err) {
        //console.error("❌ ノードが見つかりません", err);
      } finally {
        setLoading(false);
      }
    };

    fetchThread();
  }, [nodeId]);

  if (loading) return <div>チャット読み込み中...</div>;
  if (!threadType || !storyId) return <div>データが存在しません</div>;

  // threadType に応じてコンポーネント切替
  if (threadType === "story") {
    return <ChatPageWrapper userId={userId} storyId={storyId} nodeId={nodeId} />;
  } else {
    return <ChatPagemapWrapper userId={userId} storyId={storyId} nodeId={nodeId} />;
  }
};

export default ChatRouter;
